module.exports = __webpack_public_path__ + "img/3rd-Floor-SBM_SF-WFG-Airbnb-Ergo-Anywhere-sm.1cea3d96.jpg";